import { Button, Container, Group, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import classes from './PageNotFound.module.css';

export function PageNotFound() {
  const { t } = useTranslation();

  return (
    <Container className={classes.root}>
      <div className={classes.label}>404</div>
      <Title className={classes.title}>{t('pageNotFound.title')}</Title>
      <Text
        c="dimmed"
        size="lg"
        ta="center"
        className={classes.description}
      >
        Unfortunately, this is only a 404 page. You may have mistyped the address, or the page has been moved to another
        URL.
      </Text>
      <Group justify="center">
        <Button
          variant="subtle"
          size="md"
        >
          {t('pageNotFound.backHome')}
        </Button>
      </Group>
    </Container>
  );
}
